import { render } from "./NotifyPopup.vue?vue&type=template&id=6fc4b0bd&scoped=true"
import script from "./NotifyPopup.vue?vue&type=script&lang=js"
export * from "./NotifyPopup.vue?vue&type=script&lang=js"

import "./NotifyPopup.vue?vue&type=style&index=0&id=6fc4b0bd&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc4b0bd"]])

export default __exports__